type ToastFn = (item: {
  title: string
  description?: string
  variant?: 'success' | 'error' | 'info'
}) => void

let _fn: ToastFn | null = null

export const toastEmitter = {
  register: (fn: ToastFn) => {
    _fn = fn
  },
  unregister: () => {
    _fn = null
  },
  error: (title: string, description?: string) => _fn?.({ title, description, variant: 'error' }),
  success: (title: string, description?: string) =>
    _fn?.({ title, description, variant: 'success' }),
}
